import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Separator from '../components/Separator';
import FeaturedSolutions, { FeaturedItem } from '../components/FeaturedSolutions';
import tabletInfoGenesis from '../assets/products/tablet-info-genesis.png';
import appOndemandFoodTall from '../assets/products/app-ondemand-food-tall.png';
import appOrderMenuTall from '../assets/products/app-order-menu-tall.png';
import appQrQuickpayTall from '../assets/products/app-qr-quickpay-tall.png';
import digitalMenu from '../assets/products/digital-menu.png';

const DiningRoomPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page diningRoomPage">
      <Header />
      <div className="page-header">On Site Dining</div>

      <div className="text-wrapper">
        <div className="top">
          <div className="topic-header">Dining Room</div>
          <Separator />
        </div>
        <div className="std-text">
          {"Keep staff informed of residents’ seating choices, food preferences, allergies, personal celebrations, and more.\n\nTechnology enables fast, fresh, convenient delivery of food, while supporting rotating and flexible menus.\n\nGrab-and-go food and beverage options include mobile barcode scanning with advanced self-service check-out."}
        </div>
      </div>

      <FeaturedSolutions>
        <FeaturedItem
          label="InfoGenesis"
          imgSrc={tabletInfoGenesis}
          onClick={() => navigate('/solutions/info-genesis')}
        />
        <FeaturedItem
          label="IG OnDemand"
          imgSrc={appOndemandFoodTall}
          onClick={() => navigate('/solutions/ig-on-demand')}
        />
        <FeaturedItem
          label="IG Smart Menu"
          imgSrc={appOrderMenuTall}
          onClick={() => navigate('/solutions/ig-smart-menu')}
        />
        <FeaturedItem
          label="IG Quick Pay"
          imgSrc={appQrQuickpayTall}
          onClick={() => navigate('/solutions/ig-quick-pay')}
        />
        <FeaturedItem
          label="IG Digital Menu Board"
          imgSrc={digitalMenu}
          onClick={() => navigate('/solutions/digital-menu')}
        />
      </FeaturedSolutions>
    </div>
  );
};

export default DiningRoomPage;
